// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__TDhvh","sendOtp":"AuthorizeToLogin_sendOtp__2DMnH"};